
export default {
  projectName: process.env.VUE_APP_ProjectName,//项目名
  serviceUrl: getServiceUrl(), //接口地址
  apiTimeout: parseInt(process.env.VUE_APP_ApiTimeout),//接口超时时间ms   
}
//获取接口地址
function getServiceUrl() {
  
  return process.env.VUE_APP_PublishRootUrl
}
